import { GlobalState } from '@leverege/ui-redux';
import FirmwareReleaseItemDelegate from "./FirmwareReleaseItemDelegate.js";
import AbstractFotaGroupDelegate from "../AbstractFotaGroupDelegate.js";
export default class FirmwareReleaseGroupDelegate extends AbstractFotaGroupDelegate {
  constructor(options) {
    super(options);
    this.itemDelegateClass = FirmwareReleaseItemDelegate;
  }
  getApi() {
    return this.api.firmwareRelease();
  }
  pause(id) {
    return this.item(id).pause();
  }
  resume(id) {
    return this.item(id).resume();
  }
  stop(id) {
    return this.item(id).stop();
  }
  requestCanPause(id) {
    return this.item(id).requestCanPause();
  }
  requestCanResume(id) {
    return this.item(id).requestCanResume();
  }
  requestCanStop(id) {
    return this.item(id).requestCanStop();
  }
  canPause(id, state = GlobalState.get()) {
    return this.item(id).canPause(state);
  }
  canResume(id, state = GlobalState.get()) {
    return this.item(id).canResume(state);
  }
  canStop(id, state = GlobalState.get()) {
    return this.item(id).canStop(state);
  }
  releaseByImagineGroups(body, opts) {
    return this.getApi().releaseByImagineGroups(body, {
      query: opts
    });
  }
}